import { cloneDeep } from 'lodash';

import { ChartContentJson, ColumnContainerJson } from '/types';

export const createAnimationData = (
  columnData: ColumnContainerJson[],
  preChartSteps: number,
): ColumnContainerJson[][] => {
  const animationData: ColumnContainerJson[][] = [];

  const highlights: Record<string, number>[][] = [];
  columnData.forEach((column) => {
    if (column.name === 'media' && column.elements.image?.type === 'chart') {
      //remove highlights for first animation step
      const { highlight, ...options } =
        column.elements.image.spec.options || {};
      options.animation = { disable: true };
      column.elements.image.spec.options = options;
      highlights.push(highlight || []);
    } else {
      highlights.push([]);
    }
  });

  // Push initial animation step and push the same step for any pre-chart steps
  for (let i = 0; i < preChartSteps + 1; i++) {
    animationData.push(columnData);
  }

  highlights.forEach((highlight, index) => {
    const column = columnData[index];
    if (
      column.name === 'media' &&
      !('asset' in column.elements) &&
      column.elements.image?.type === 'chart'
    ) {
      highlight.forEach((_, i) => {
        const newColumn = cloneDeep(column);
        // Type has already been checked above so force the type system
        const chart = newColumn.elements.image as ChartContentJson;

        chart.spec.options.highlight = highlight.filter((_, j) => i === j);

        // Copy over columns from  previous step to preserve continuity
        const newColumns = cloneDeep(animationData[animationData.length - 1]);
        // Overwrite chart with specific animation step highlights
        newColumns[index] = newColumn;
        animationData.push(newColumns);
      });
    }
  });

  // Allow animations on render if previous highlights differ from current step
  animationData.forEach((columns, i, columnArr) => {
    columns.forEach((column, j) => {
      if (
        column.name === 'media' &&
        column.elements.image?.type === 'chart' &&
        i > 0
      ) {
        const currentHighlights = column.elements.image.spec.options.highlight;
        const prevCol = columnArr[i - 1][j];
        let prevHighlights;
        if (
          prevCol.name === 'media' &&
          prevCol.elements.image?.type === 'chart'
        ) {
          prevHighlights = prevCol.elements.image.spec.options.highlight;
        }
        if (
          JSON.stringify(currentHighlights) !== JSON.stringify(prevHighlights)
        ) {
          column.elements.image.spec.options.animation.disable = false;
        }
      }
    });
  });

  return animationData;
};
